import { NamedLocationAdapter } from './NamedLocationAdapter';
export class LocationValidateQueryAdapter {
    static fromGraphQL(queryResult) {
        if (!queryResult || !queryResult.validateLocation) {
            return {
                isValid: false,
                location: undefined,
                formattedName: '',
            };
        }
        const componentResult = {
            location: NamedLocationAdapter.fromGraphQL(queryResult.validateLocation.location),
            formattedName: queryResult.validateLocation.formattedName || '',
            isValid: true,
        };
        return componentResult;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTG9jYXRpb25WYWxpZGF0ZVF1ZXJ5QWRhcHRlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy91cml0aGlydS1jbGllbnQvYWRhcHRlcnMvTG9jYXRpb25WYWxpZGF0ZVF1ZXJ5QWRhcHRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQUUsb0JBQW9CLEVBQUUsTUFBTSx3QkFBd0IsQ0FBQztBQUU5RCxNQUFNLE9BQU8sNEJBQTRCO0lBQzlCLE1BQU0sQ0FBQyxXQUFXLENBQ3JCLFdBQThDO1FBRTlDLElBQUksQ0FBQyxXQUFXLElBQUksQ0FBQyxXQUFXLENBQUMsZ0JBQWdCLEVBQUUsQ0FBQztZQUNoRCxPQUFPO2dCQUNILE9BQU8sRUFBRSxLQUFLO2dCQUNkLFFBQVEsRUFBRSxTQUFTO2dCQUNuQixhQUFhLEVBQUUsRUFBRTthQUNZLENBQUM7UUFDdEMsQ0FBQztRQUNELE1BQU0sZUFBZSxHQUFpQztZQUNsRCxRQUFRLEVBQUUsb0JBQW9CLENBQUMsV0FBVyxDQUFDLFdBQVcsQ0FBQyxnQkFBZ0IsQ0FBQyxRQUFRLENBQUM7WUFDakYsYUFBYSxFQUFFLFdBQVcsQ0FBQyxnQkFBZ0IsQ0FBQyxhQUFhLElBQUksRUFBRTtZQUMvRCxPQUFPLEVBQUUsSUFBSTtTQUNoQixDQUFDO1FBQ0YsT0FBTyxlQUFlLENBQUM7SUFDM0IsQ0FBQztDQUNKIn0=